var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C11 7.0878 10.6774 8.15117 10.0731 9.05564C9.46873 9.96011 8.60975 10.6651 7.60476 11.0813C6.59977 11.4976 5.4939 11.6065 4.427 11.3943C3.36011 11.1821 2.3801 10.6583 1.61091 9.88909C0.841724 9.1199 0.3179 8.13989 0.105681 7.073C-0.106538 6.0061 0.0023806 4.90023 0.418663 3.89524C0.834945 2.89025 1.53989 2.03126 2.44436 1.42692C3.34883 0.822569 4.4122 0.5 5.5 0.5V1.875C4.68415 1.875 3.88663 2.11693 3.20827 2.57019C2.52992 3.02345 2.00121 3.66769 1.689 4.42143C1.37679 5.17518 1.2951 6.00458 1.45426 6.80475C1.61342 7.60492 2.00629 8.33992 2.58318 8.91682C3.16008 9.49371 3.89508 9.88658 4.69525 10.0457C5.49542 10.2049 6.32482 10.1232 7.07857 9.811C7.83231 9.49879 8.47655 8.97008 8.92981 8.29173C9.38307 7.61337 9.625 6.81585 9.625 6H11Z",
    fill: "#15A9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSpinner);
export default __webpack_public_path__ + "static/media/status-spinner.6f0449de8fcf16ed6722812e301a70e2.svg";
export { ForwardRef as ReactComponent };